import { sortNumber } from '../../utils/sort/sortNumber';
import { sortNumberOrString } from '../../utils/sort/sortNumberOrString';
import { sortNumberWithPrefix } from '../../utils/sort/sortNumberWithPrefix';
import { sortString } from '../../utils/sort/sortString';
import { OrderType } from '../schemas';
import { columnsExtension } from './columnsExtension';
import { DataPpmShareData, Row } from './types';

export const sortPpmShare = (
  data: DataPpmShareData | undefined,
  order: OrderType,
  sort: string
): DataPpmShareData | undefined => {
  if (data == null) {
    return data;
  }

  const flatColumns = columnsExtension(data.columns);
  const sortIndex = flatColumns.findIndex((column) => column.code === sort);
  if (sortIndex < 0) {
    return data;
  }

  const sortType = flatColumns.at(sortIndex)?.type;

  const sortedRows = ((): Row[] | undefined => {
    switch (sortType) {
      case 'string':
        return sortString(data.rows, sortIndex, order);
      case 'number':
        return sortNumber(data.rows, sortIndex, order);
      case 'numberWithPrefix':
        return sortNumberWithPrefix(data.rows, sortIndex, order);
      case 'numberOrString':
        return sortNumberOrString(data.rows, sortIndex, order);
      default:
        return undefined;
    }
  })();

  if (sortedRows == null) {
    return data;
  }

  return {
    ...data,
    rows: sortedRows,
  };
};
